import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { TelephoneFill, GeoAltFill } from "react-bootstrap-icons";
import TrialForm from "../../components/form/form.js";
import { contactInfo } from "../../data/address_contact";
import "./contactPage.css";

const ContactPage = () => {
  return (
    <div className="contact-page-wrapper">
      <Container fluid className="contact-container col-md-11 mx-auto py-5 rounded-4">
        <Row className="mb-4 ">
          <Col xs={12} className=" col-lg-11 mx-auto">
            <h1 className="contact-title">
              {contactInfo.heading}
            </h1>
            <p className="contact-subtitle">
              {contactInfo.subHeading}
            </p>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center align-items-stretch">
          <Col xs={12} lg={4} className="col-11 col-lg-4 d-flex">
            <div className="contact-card-wrapper rounded-4">
              <Card className="contact-card">
                <p className="contact-description">
                  {contactInfo.description}
                </p>

                {/* Phone */}
                <Row className="align-items-center mb-4">
                  <Col xs="auto">
                    <div className="contact-icon-box">
                      <TelephoneFill color="white" size={22} />
                    </div>
                  </Col>

                  <Col>
                    <div className="contact-label">
                      <link TelephoneFill></link>
                      {contactInfo.phoneLabel}</div>
                    <div className="contact-text">
                        <a className="text-decoration-none text-dark " href={`tel:${contactInfo.phoneNumber}`}>
                      {contactInfo.phoneNumber} </a> </div>
                  </Col>
                </Row>

                <Row className="align-items-start">
                  <Col xs="auto">
                    <div className="contact-icon-box">
                      <GeoAltFill color="white" size={22} />
                    </div>
                  </Col>

                  <Col>
                    <div className="contact-label">{contactInfo.locationLabel}</div>
                    <div className="contact-text">
                      {contactInfo.addressLines.map((line, index) => (
                        <span key={index}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </div>
                  </Col>
                </Row>
              </Card>
            </div>
          </Col>

          <Col xs={12} lg={7} className="col-11 col-lg-7 d-flex">
            <div className="contact-form-wrapper rounded-4">
              <TrialForm
                className="rounded-4"
                buttonStyle={{
                  padding: "12px 60px",
                  borderRadius: "25px",
                  width: "100%"
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="py-5">
      <Row className="justify-content-center">
        <Col>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.489903338627!2d101.55862359999999!3d3.2274984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc451201007ec9%3A0x71991bb3c48074aa!2sStudio-V%20Fitness%20Centre!5e0!3m2!1sen!2sin!4v1772780211932!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Studio-V Fitness Centre location map"
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default ContactPage;
